module.exports = __webpack_public_path__ + "img/red.9446f40a.png";